// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__F174J","link__icon":"styles_link__icon__mB8cn","skeleton-animation":"styles_skeleton-animation__IAvih"};